import React, { useMemo } from "react";
import styled from "styled-components";
import { ButtonOutlined } from "../../Reusablecomponents/UIButtons";
import { LeftOutlined } from "@ant-design/icons";
import { Tooltip, Col, Row } from "antd";
import { ReactComponent as DeleteIcon } from "../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon } from "../../assets/images/Editicon.svg";
import dayjs from "dayjs";
import { useSelector } from "react-redux";

const WrapperBox = styled.div`
  .consingment_container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    .consingment_container {
      display: flex;
      flex-direction: column;
    }
    .consingment_container_two {
      display: flex;
      gap: 10px;
    }
    .consingment_container_formbresponsive {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: end;
    }
    .container_for_consignorpage {
      .consignor_code {
        width: 100% !important;
      }
    }
  }
  @media (min-width: 481px) and (max-width: 768px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 50% !important;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 33% !important;
      }
    }
  }
  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  p {
    margin-bottom: 0px;
    line-height: normal;
    font-size: 16px;
    font-weight: 400;
  }
  .consignor_code > label {
    color: rgb(152, 161, 181);
    padding: 5px 0px 5px 0px;
    font-size: 14px;
    display: block;
    margin-bottom: 4px;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(235, 247, 237);
    color: white;
    border-radius: 50%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }
  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .Create_btn_edit {
    border-radius: 50%;
    padding: 9px;
    border: 1px solid rgb(231, 231, 237);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(235, 247, 237);
  }
  .container_for_consignorpage {
    background-color: rgb(248, 248, 248);
    border-radius: 12px;
    margin: 16px 5px 20px 5px;
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 10px;
    flex-wrap: wrap;
  }
  .consignor_code {
    width: 25%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
`;

const NexusFuelDetailsAI = ({
  setDetailsOpen,
  record,
  updateAllowed,
  deleteAllowed,
  onEdit,
  onDelete,
}) => {
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );

  const transporterName = useMemo(() => {
    if (record?.TransporterName) return record.TransporterName;
    const found = transporterList?.find(
      (item) => item.ID === record?.TransporterId,
    );
    return found?.Name || "---";
  }, [record, transporterList]);

  return (
    <>
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="consingment_container">
              <div className="consingment_container_two">
                <ButtonOutlined
                  onClick={() => setDetailsOpen(false)}
                  className="Create_btn"
                >
                  <LeftOutlined className="left_outlined_icon" />
                </ButtonOutlined>
                <p>Fuel Details - {record?.VehRegNo}</p>
              </div>

              <div className="consingment_container_two consingment_container_formbresponsive">
                <Tooltip title={!updateAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <EditIcon
                      style={{
                        cursor: updateAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={(e) => {
                        if (!updateAllowed) return;
                        e.stopPropagation();
                        onEdit(record);
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>

                <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                  <ButtonOutlined
                    style={{
                      cursor: deleteAllowed ? "pointer" : "not-allowed",
                    }}
                    className="Create_btn_edit"
                    onClick={() => {
                      if (!deleteAllowed) return;
                      onDelete(record?.Id);
                    }}
                  >
                    <DeleteIcon />
                  </ButtonOutlined>
                </Tooltip>
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="container_for_consignorpage">
              <div className="consignor_code">
                <label>Vehicle</label>
                <p>{record?.VehRegNo || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Fuel Date</label>
                <p>
                  {record?.FuelDate
                    ? dayjs(record.FuelDate).format("Do MMM YYYY; hh:mm A")
                    : "-"}
                </p>
              </div>
              <div className="consignor_code">
                <label>Litres Fueled</label>
                <p>{record?.LitresFueled ?? "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Price Per Litre</label>
                <p>{record?.PricePerLitre ?? "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Amount</label>
                <p>{record?.Amount ?? "-"}</p>
              </div>
              <div className="consignor_code">
                <label>ODO Reading</label>
                <p>{record?.OdoReading ?? "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Mileage</label>
                <p>{record?.Mileage ?? "0"}</p>
              </div>
              <div className="consignor_code">
                <label>Fuel Text</label>
                <p>{record?.FuelText || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Transporter</label>
                <p>{transporterName}</p>
              </div>
              <div className="consignor_code">
                <label>Fuel Type</label>
                <p>{record?.FuelType || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>AI Fuel Type</label>
                <p>{record?.AIFuelType || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Station Name</label>
                <p>{record?.StationName || "-"}</p>
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>
    </>
  );
};

export default NexusFuelDetailsAI;
